import { NgModule } from '@angular/core';
import { ArticleFeatureModule } from '@article/feature';
import { ArticleCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        article: {
          module: () => import('./article-lazy.module').then((m) => m.ArticleLazyModule),
          cmsComponents: Object.values(ArticleCmsComponents),
        },
      },
    }),
    ArticleFeatureModule,
  ],
})
export class SdvorArticleShellModule {}
